export default __webpack_public_path__ + "static/media/what-you-need.1250cc3d.md";